const ls = require("local-storage");


export const getFromLocalStorage = (key) => ls.get(key);